import { get } from 'communication/httpClient';
import { LOAD_LOCATIONS, LOCATIONS_LOADED, SYNC_FAILED } from './actionTypes';

export const initialActionsState = {
  loadLocationsHierarchy: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadLocationsHierarchy: async () => {
    dispatch({
      type: LOAD_LOCATIONS,
    });
    const { data, error } = await get('/api/business-units/hierarchyLookups');

    if (data) {
      dispatch({
        type: LOCATIONS_LOADED,
        payload: [data],
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
});
